// extracted by mini-css-extract-plugin
export var addToCartButton = "_te-b";
export var arrowButtonContainer = "_te-9";
export var arrowButtonIcon = "_te-a";
export var carouselArrowButton = "_te-6";
export var carouselElementContainer = "_te-1";
export var left = "_te-7";
export var productDisplayCarouselContainer = "_te-0";
export var productTileContainer = "_te-2";
export var productTileImage = "_te-4";
export var productTileImageContainer = "_te-3";
export var productTileTitle = "_te-5";
export var right = "_te-8";
export var sliderOverflow = "_te-c";